module.exports = __webpack_public_path__ + "static/media/bdp.1ef97b1c.png";